module.exports = function (bootstrap) {
    return bootstrap.getBootstrappedData(bootstrap.bootstrapped.Config) || {};
};



// WEBPACK FOOTER //
// ./src/common/config/config-factory.js